import { createFileRoute, Outlet } from "@tanstack/react-router";
import Auth from "@/modules/auth";
import Layout from "@/components/layout";
import PrivyProviders from "@/providers/privy-provider";

export const Route = createFileRoute("/_private/_layout")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivyProviders>
      <Auth>
        <Layout>
          <Outlet />
        </Layout>
      </Auth>
    </PrivyProviders>
  );
}
